import React from 'react';
import { Modal, Fade, Backdrop } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { isMobile } from 'react-device-detect';
import { Formik } from 'formik';
import CollaboratorPositionForm from '../../pages/Profile/Add/CollaboratorPositionForm';

const useStyles = makeStyles({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        display: 'flex',
        flexDirection: 'Column',
        width: isMobile ? 328 : 448,
        height: isMobile ? 345 : 360,
        borderRadius: 4,
        padding: isMobile ? '24px 16px' : 24,
        boxShadow: '0 15px 15px 0 rgba(0, 40, 62, 0.3)',
        backgroundColor: 'white',
        '&:focus': {
            outline: 'none',
        },
    },
    infoWrapper: {
        display: 'flex',
        flexFlow: 'column',
        alignItems: 'flex-start',
    },
    name: {
        fontSize: 22,
        color: '#10587f',
        textAlign: 'left',
        marginBottom: 21,
        fontWeight: 'bold',
    },
    subname: {
        fontSize: 16,
        color: '#484848',
        textAlign: 'left',
        margin: isMobile ? '0 0 34px 0' :  '0 85px 34px 0',
    },
})

function PopUp({ 
    open,
    title,
    subtitle,
    handleClose,
    handleActive,
    initialValues,
    primaryFunction,
    validationSchema,
    collaboratorPosition,
    secondaryOptionalFunctionForCancel,
  })
{
    const classes = useStyles()

    const closeModal = (event) => {
      event.preventDefault()
      handleActive()
      handleClose()
      if (secondaryOptionalFunctionForCancel) {
        secondaryOptionalFunctionForCancel()
      }
    }

    const handleSubmit = (values) => {
      handleClose()
      handleActive(values.collaboratorPosition)
      primaryFunction()
    };
 
    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <div className={classes.infoWrapper}>
              {title ?
                <div>
                  <p className={classes.name}>
                    {title}
                  </p>
                </div> :
                null
              }
              
              {subtitle ?
                <div className={classes.subname}>
                  <span>
                    {subtitle}
                  </span>
                </div> :
                null
              }
              
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema && validationSchema}
                onSubmit={handleSubmit}
                render={props => (
                  <CollaboratorPositionForm
                    {...props}
                    handleClose={closeModal}
                  />
                )}
              />
              
            </div>
          </div>
        </Fade>
      </Modal>
    )
}

export default PopUp;
